import React from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import EndorsementMotivationForm from '../../../components/forms/EndorsementMotivationForm';
import { useCreateEndorsementMotivation } from '../../../hooks/useEndorsementMotivationApi';
import { useNavigate } from 'react-router-dom';
import { EndorsementMotivationDTO } from '../../../services/apiClient';

const EndorsementMotivationCreate: React.FC = () => {
  const createMutation = useCreateEndorsementMotivation();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Endorsement Motivations', href: '/admin/endorsementmotivations' },
    { label: 'Create', href: '#' },
  ];

  const handleSubmit = async (data: EndorsementMotivationDTO) => {
    try {
      await createMutation.mutateAsync(data);
      navigate('/admin/endorsementmotivations');
    } catch (error) {
      console.error('Error creating EndorsementMotivation:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/endorsementmotivations"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Settings.EndorsementMotivation.Edit'
    >
        <EndorsementMotivationForm
          initialValues={{} as EndorsementMotivationDTO}
          onSubmit={handleSubmit}
          onCancel={() => navigate('/admin/endorsementmotivations')}
        />
    </AdminLayout>
  );
};

export default EndorsementMotivationCreate;